import React from 'react';
import '../../App.css';
import './Tournaments.css';
import '../HeroSection.css';
import { Button } from '../Button';
import Footer from '../Footer';
import U13Info from '../U13Info';
import { useLang } from '../../i18n';
import RegistrationForm from '../RegistrationForm';

export default function U13() {
  const { t } = useLang();
  const [showReg, setShowReg] = React.useState(false);
  const handleButtonClick = (url, isDownload = false) => {
    if (isDownload) {
      const link = document.createElement('a');
      link.href = url;
      link.download = url.split('/').pop(); // Extracts the file name from the URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const newWindow = window.open(url, '_blank');
      if (newWindow) newWindow.focus();
    }
  };

  return (
    <React.Fragment>
      <div className='u13'>
        <div className='hero-container_tournament'>
          <h1>Slovak Youth U13</h1>
          <span className='label deadline'>{t('tournament.entryDeadline')} {t('tournament.deadlineU13')}</span>
          <p>{t('tournament.eventDate')}</p>

          <div className='tournaments-btns'>
            <Button 
              className='btns'
              buttonStyle='btn--outline'
              buttonSize='btn--large'
              onClick={() => handleButtonClick('/documents/SlovakYouthU13Invitation.pdf')}
            >
              {t('tournament.invitation')}
            </Button>

            {/* Online registration modal replaces the old .xlsx entry form download */}
            <button
              className='btn btn--primary btn--large'
              onClick={() => setShowReg(true)}
            >
              {t('tournament.register')}
            </button>

            <Button 
              className='btns'
              buttonStyle='btn--primary'
              buttonSize='btn--large'
              onClick={() => handleButtonClick('https://www.tournamentsoftware.com')}
            >
              {t('tournament.draws')}
            </Button>
          </div>

          {/* <div className='tournaments-info-wrapper'>
            <div className='tournaments-info'>
            ⓘ Provisional times can be changed subject to the number of entries. 
            </div>
            <div className='tournaments-info'>
            Singles will be played in groups in first stage, then by KO system,
            doubles will be played by KO system.
            In the event of any dispute, the Referee´s decision shall be final.
            </div>
          </div> */}

        </div>
      </div>
      {showReg && <RegistrationForm tournament='U13' onClose={() => setShowReg(false)} />}
      <U13Info />
      <Footer />
    </React.Fragment>
  );
}